import type { Ref } from 'vue'

interface UseIdentityAnalytics {
  /** The value AY gets as its HEM provider dimension, once identity resolves. */
  hemProvider: Ref<string | undefined>
  /**
   * Whether the HEM provider's script loaded. Undefined until the provider
   * tries to load it, which only happens after consent allows identity.
   */
  hemScriptLoaded: Ref<boolean | undefined>
}

export function useIdentityAnalytics(): UseIdentityAnalytics {
  return {
    hemProvider: useState<string | undefined>('hemProvider', () => undefined),
    hemScriptLoaded: useState<boolean | undefined>(
      'hemScriptLoaded',
      () => undefined
    ),
  }
}
